import React, { type ReactNode } from "react";
import { cn } from "@/utils/cn";
import { SpinnerIcon } from "@/components/icons";
import { normalizeToSlots } from "./types/grid.types";
import type { GridItem } from "./types/grid.types";

interface PlanningGridProps {
  items: GridItem[];
  renderSlot: (item: GridItem, position: number) => ReactNode;
  className?: string;
  slotClassName?: string;
  isLoading?: boolean;
}

export const PlanningGrid: React.FC<PlanningGridProps> = ({
  items,
  renderSlot,
  className,
  slotClassName,
  isLoading,
}) => {
  const slots = normalizeToSlots(items);

  return (
    <div className="relative h-full flex items-center justify-center">
      {isLoading && (
        <div className="absolute inset-0 bg-white/80 backdrop-blur-xs z-10 flex items-center justify-center">
          <div className="flex items-center space-x-2">
            <SpinnerIcon className="w-4 h-4" />
            <span>Loading grid...</span>
          </div>
        </div>
      )}

      <div className={cn("grid grid-cols-3 grid-rows-4 gap-1", className)}>
        {slots.map((item) => (
          <div
            key={`position-${item.position}`}
            className={cn("aspect-4/5", slotClassName)}
          >
            {renderSlot(item, item.position)}
          </div>
        ))}
      </div>
    </div>
  );
};
